import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import ModernPageShell from "components/ModernPageShell";

export default function TermCondition() {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir();
  const settings = useSelector(state => state.settingsdata.settings);
  return (
    <ModernPageShell title={t('term_condition')}>
      {settings && settings.termsContent ?
            <p style={{whiteSpace:'pre-line'}}>{settings.termsContent}</p>
            :
            <>
            <p  >{t('term_condition_para1')}</p>
            <br/>
            <p  >
            <strong>{t('term_condition_heading1')}</strong>
            </p>
            <p  >
                {t('term_condition_para2')}
            </p>
            <p  >
            <strong>{t('term_condition_heading2')}</strong>
            </p>
            <p  >
                {t('term_condition_para3')}
            </p>
            <p  >
            <strong>{t('term_condition_heading3')}</strong>
            </p>
            <p  >
                {t('term_condition_para4')}
            </p>
            <p  >
            <strong>{t('term_condition_heading4')}</strong>
            </p>
            <p  >
                {t('term_condition_para5')}
            </p>
            <p  >
            <strong>{t('term_condition_heading5')}</strong>
            </p>
            <p  >
                {t('term_condition_para6')}
            </p>
            <p  >
            <strong>{t('term_condition_heading6')}</strong>
            </p>
            <p  >
                {t('term_condition_para7')}
            </p>
            <p  >
            <strong>{t('term_condition_heading7')}</strong>
            </p>
            <p  >
                {t('term_condition_para8')}
            </p>
            <p  >
            <strong>{t('term_condition_heading8')}</strong>
            </p>
            <p  >
                {t('term_condition_para9')}
            </p>
            <p  >
            <strong>{t('term_condition_heading9')}</strong>
            </p>
            <p  >
                {t('term_condition_para10')}
            </p>
            <p  >
            <strong>{t('term_condition_heading10')}</strong>
            </p>
            <p  >
                {t('term_condition_para11')}
            </p>
            <p  >
            <strong>{t('term_condition_heading11')}</strong>
            </p>
            <p  >
                {t('term_condition_para12')}
            </p>
            <p  >
            <strong>{t('term_condition_heading12')}</strong>
            </p>
            <p  >
                {t('term_condition_para13')}
            </p>
          <p  >
          {t('term_condition_para14')} 
          {settings && settings.contact_email?
            <a href={"mailto:" + settings.contact_email}><strong>{settings.contact_email}</strong></a>
          :null}
          </p>
          </>
          }
    </ModernPageShell>
  );
}
